import { Outlet, useNavigate } from 'react-router'
import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { AuthenticationEvents, LoginSuccessEventKey } from '~/pages/Login/Login.component'

export const OidcGuardOutlet = () => {
  const { search } = useLocation()
  const navigate = useNavigate()
  const eventHandler = () => {
    const queryParams = new URLSearchParams(search)
    const serverRedirectUri = queryParams.get('ReturnUrl')
    if (serverRedirectUri) {
      window.location.href = decodeURIComponent(serverRedirectUri)
    }
    else{
      navigate('/')
    }
  }
  useEffect(() => {
    AuthenticationEvents.addEventListener(LoginSuccessEventKey, eventHandler)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <Outlet />
}

export default OidcGuardOutlet
